import titleSvg from "../../assets/fableous_title.svg";
import ResponsiveImage from "../layout/ResponsiveImage";

export default function FableousTitle({maxHeight} : {maxHeight? : number}){
    return (
        <ResponsiveImage alt="Fableous logo title" originalHeight={138} originalWidth={590} url={titleSvg} maxHeight={maxHeight}/>
    )
}